/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-30 10:06:44
 * @LastEditors: K
 * @LastEditTime: 2022-10-08 16:28:28
 */
import { ADMIN_API_PREFIX, API_PREFIX } from './constant'
import { Request } from './request'
export interface getMembersPageFnParams {
  size?: number
  current?: number
  endTime?: string
  startTime?: any
  labelIds?: string
  keyWord?: any
  // 排序字段
  memberNameSort?: number
  cardNoSort?: number
  balanceMoneySort?: number
  createTimeSort?: number
  pointSort?: number
}
//  会员管理-列表
export const getMembersPageFn = (params: getMembersPageFnParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/memberPage`,
    method: 'GET',
    params,
  }
}

//  会员管理-新增
export interface getAddMembersFnParams {
  age?: string
  balanceMoney?: number
  birthday?: string
  createUser?: string
  labelIds?: string
  memberName?: string
  memberPhone?: number
  remarks?: string
  sexType?: string
  patientId?: number
  ageYear?: number
  ageMonth?: number
  idCardNumber?: string
}
export const getAddMembersFn = (body: getAddMembersFnParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/saveMember`,
    method: 'POST',
    body,
  }
}

export const getMembersDetailFn = (memberId: any): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getMemberOne`,
    method: 'GET',
    params: { memberId },
  }
}

// 会员管理-删除会员
export const removeMemberFn = (params: { id?: any }): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/remove`,
    method: 'GET',
    params,
  }
}

// 逻辑删除会员
export const delMemberFn = (params: { id?: any }): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/del`,
    method: 'GET',
    params,
  }
}


//  会员管理-新增会员-操作人
export const getAddMembersOperationFn = (): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getCreateList`,
    method: 'GET',
  }
}
//  会员管理-会员基础信息
export interface getMembersBaseInfoFnParams {
  memberId?: number
}
export const getMembersBaseInfoFn = (
  params: getMembersBaseInfoFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getMemberBasicsDetails`,
    method: 'GET',
    params,
  }
}
//  会员管理-充值 or 退款详情信息
export const getMembersInfoFn = (
  params: getMembersBaseInfoFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getMemberDetails`,
    method: 'GET',
    params,
  }
}
//  会员管理-充值 or 退款
export interface getMembersTopUpFnParams {
  createUser?: string
  memberId?: number
  money?: number
  remark?: string
  type?: number
}
export const getMembersTopUpFn = (body: getMembersTopUpFnParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/rechargeRefund`,
    method: 'POST',
    body,
  }
}
//  会员管理-充值记录
export interface getMembersTopUpRecordFnParams {
  memberId?: number
  current?: number
  size?: number
  type?: number
  startTime?: string
  endTime?: string
  memberName?: string
  keyWord?: string
}
export const getMembersTopUpRecordFn = (
  params: getMembersTopUpRecordFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getTenantRechargeList`,
    method: 'GET',
    params,
  }
}
//  会员管理-充值/消费记录导出
export const exportTenantRechargeListFn = (
  params: getMembersTopUpRecordFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/exportTenantRechargeList`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}
//  会员管理-会员充值/消费记录（充值 type=0，消费 type=1）
export const getRechargeListFn = (
  params: getMembersTopUpRecordFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getRechargeList`,
    method: 'GET',
    params,
  }
}
//  药品零售-搜索会员
export interface getSearchMembersFnParams {
  memberPhone?: number
}
export const getSearchMembersFn = (
  params: getSearchMembersFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/searchMember`,
    method: 'GET',
    params,
  }
}

// 会员管理-搜索会员-通过会员卡号
export const getSearchMembersByCardNoFn = (
  params: getSearchMembersFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/searchMemberOrMemberCard`,
    method: 'GET',
    params,
  }
}

export interface getSearchMembersByPhoneParams {
  keyword?: string
}
// 会员管理-搜索会员-通过手机号
export const getSearchMembersByPhoneFn = (
  params: getSearchMembersByPhoneParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/searchMembers`,
    method: 'GET',
    params,
  }
}

//  药品零售-搜索会员
export interface AddOrEditMemberCardFnParams {
  balance?: any
  cardNo?: any
  remark?: any
  cardType?: number
  id?: any
}
export const getAddMemberCardFn = (
  body: AddOrEditMemberCardFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/addMemberCard`,
    method: 'POST',
    body,
  }
}

// 会员卡编辑
export const getEditMemberCardFn = (
  body: AddOrEditMemberCardFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/update`,
    method: 'POST',
    body,
  }
}

// 会员卡编辑详情
export interface EditMemberCardParams {
  memberCardId?: number
}
export const getEditMemberCardDetailFn = (
  params: EditMemberCardParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/detail`,
    method: 'GET',
    params,
  }
}

// 会员卡删除
export interface DeleteMemberCardParams {
  id?: number
}
export const deleteMemberCardFn = (
  body: DeleteMemberCardParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/delete`,
    method: 'POST',
    body,
  }
}
// 会员卡解绑
export interface UnbindMemberCardParams {
  memberCardId?: number
}
export const unbindMemberCardFn = (
  body: UnbindMemberCardParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/unBindMemberCard`,
    method: 'POST',
    body,
  }
}
// 会员卡绑定
export interface BindMemberParams {
  memberCardId?: any
  memberId?: any
  pageName?: any
}
export const bindMemberFn = (body: BindMemberParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/memberCardBind`,
    method: 'POST',
    body,
  }
}
// 会员卡列表
export interface MemberCardListParams {
  current?: number
  size?:any
  bindState?: any
  param?: any
  timeHead?: any
  timeTail?: any
}
export const getMemberCardListFn = (params: MemberCardListParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/page`,
    method: 'GET',
    params,
  }
}

 export const getMemberCardSearchListFn = (params: MemberCardListParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/selectMemberCardWithNoBind`,
    method: 'GET',
    params,
  }
}

// 会员管理-兑换记录
export interface getExchangeRecordFnParams {
  memberId?: number
  current?: number
  size?: number
  startTime?: string
  endTime?: string
  memberName?: string
}
export const getExchangeRecordFn = (
  params: getExchangeRecordFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPointExchangeRecord/detail`,
    method: 'GET',
    params,
  }
}

// 会员管理-兑换记录分页列表
export interface getExchangeRecordPageFnParams {
  current?: number
  size?: number
  keyWord?: string
  startTime?: string
  endTime?: string
}
export const getExchangeRecordPageFn = (
  params: getExchangeRecordPageFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPointExchangeRecord/page`,
    method: 'GET',
    params,
  }
}

// 会员管理-兑换记录导出
export const exportExchangeRecordFn = (
  params: getExchangeRecordPageFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPointExchangeRecord/export`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

// 会员管理-积分配置详情
export interface MemberPointConfigurationDetail {
  // 会员积分开关总状态
  state?: boolean
  // 主键id
  id?: number
  // 积分获取规则启用开关:0关闭，1启用
  obtainState?: number
  // 积分对应消费金额
  price?: number
  // 消费金额对应获取的积分
  point?: number
  // 积分获取范围:0全部，1指定
  obtainRange?: number
  // 积分清零开关: 0永久有效，1固定日期，2滚动日期
  resetType?: number
  // 清空积分的具体月
  month?: number
  // 清空积分的具体天
  day?: number
}
export const getMemberPointConfigurationDetailFn = (): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPointConfiguration/detail`,
    method: 'GET',
  }
}

// 会员管理-积分配置保存
export interface MemberPointConfigurationSubmitParams {
  state?: boolean
  obtainState?: number
  price?: number
  point?: number
  obtainRange?: number
  resetType?: number
  month?: number
  day?: number
}
export const submitMemberPointConfigurationFn = (
  body: MemberPointConfigurationSubmitParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPointConfiguration/submit`,
    method: 'POST',
    body,
  }
}

// 会员积分-参与项目列表（catalogType: 0 商品, 1 诊疗；type: 0 兑换范围, 1 参与范围）
export interface MemberPointParticipatoryListParams {
  current?: number
  size?: number
  catalogType?: number
  type?: number
  [key: string]: any
}
export const getMemberPointParticipatoryListFn = (
  params: MemberPointParticipatoryListParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPoint/participatoryList`,
    method: 'GET',
    params,
  }
}

// 会员积分-参与/兑换项目分页列表（isExchange: 0 兑换范围, 1 参与范围）
export interface MemberPointPageParams {
  current?: number
  size?: number
  isExchange?: number
  [key: string]: any
}
export const getMemberPointPageFn = (params: MemberPointPageParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPoint/page`,
    method: 'GET',
    params,
  }
}

// 会员积分-保存添加的商品/诊疗/分类（body 为数组）
export const submitMemberPointFn = (body: any[]): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPoint/submit`,
    method: 'POST',
    body,
  }
}

// 会员积分-兑换记录保存
export interface SubmitMemberPointExchangeRecordParams {
  memberId?: number
  type?: number
  tenantCatalogId?: any
  catalogType?: number
  number?: number
  point?: number
  remark?: string
}
export const submitMemberPointExchangeRecordFn = (
  body: SubmitMemberPointExchangeRecordParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPointExchangeRecord/submit`,
    method: 'POST',
    body,
  }
}

// 会员积分-兑换记录退货（POST，params 传 id）
export const refundMemberPointExchangeRecordFn = (
  params: { id?: any }
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPointExchangeRecord/refund`,
    method: 'POST',
    params,
  }
}

// 会员积分-删除参与/兑换项目（type: 0 兑换范围, 1 参与范围）
export interface DeleteMemberPointParams {
  id?: any
  type?: number
}
export const deleteMemberPointFn = (params: DeleteMemberPointParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPoint/delete`,
    method: 'GET',
    params,
  }
}

// 会员积分-例外列表（billingCategory 开票项目，catalogType: 0 商品, 1 诊疗）
export interface MemberPointExceptionListParams {
  billingCategory?: string
  catalogType?: number
  [key: string]: any
}
export const getMemberPointExceptionListFn = (
  params: MemberPointExceptionListParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPointException/list`,
    method: 'GET',
    params,
  }
}

// 会员积分-例外保存（body 为 { memberPointExceptions: [...] }，DTO 字段 tenantCatalogId / billingCategory / catalogType）
export const submitMemberPointExceptionFn = (body: any): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPointException/submit`,
    method: 'POST',
    body,
  }
}

// 会员积分-例外分页列表（编辑例外时使用，billingCategory 传当前编辑的开票项目，catalogType: 0 商品, 1 诊疗）
export interface MemberPointExceptionPageParams {
  billingCategory?: string
  catalogType?: number
  current?: number
  size?: number
  [key: string]: any
}
export const getMemberPointExceptionPageFn = (
  params: MemberPointExceptionPageParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/memberPointException/pageGoods`,
    method: 'GET',
    params,
  }
}